import { Sidebar } from '@/shared/components/ui/Sidebar';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import './styles.css';

interface MainLayoutProps {
  children?: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const location = useLocation();
  const hideSidebar = location.pathname === '/reports/v2/edit' || location.pathname.startsWith('/reports/v2/edit/') || location.pathname.startsWith('/batch/edit/');
  const compactAdmin = location.pathname === '/org' || location.pathname.startsWith('/org/') || location.pathname === '/super';

  return (
    <div className={`main-layout${compactAdmin ? ' main-layout--admin' : ''}`}>
      {!hideSidebar && <Sidebar compactAdmin={compactAdmin} />}
      <main className={`main-content${hideSidebar ? ' main-content--no-sidebar' : ''}`}>{children}</main>
    </div>
  );
};